import styled from 'styled-components';

import { spaceXS } from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  flex-wrap: nowrap;
`;

export const OverflowLabel = styled.span<{ $overflowHighlight: boolean }>`
  margin-left: ${spaceXS};
  visibility: hidden;
  opacity: 0;
  position: absolute;

  font-weight: ${({ $overflowHighlight }) =>
    $overflowHighlight ? '700' : 'normal'};

  &.visible {
    visibility: visible;
    opacity: 1;
    position: static;
  }
`;
